/**
 * Reconnecting never gives up (its delay is capped). Only an outage longer
 * than this reads as "failed", so a brief backend restart never surfaces an
 * error.
 */
export const FAILED_AFTER_MS = 60_000;

/** Times one connection outage and calls `onFailed` once it lasts too long. */
export class WsOutageClock {
  private timer: ReturnType<typeof setTimeout> | null = null;
  private expired = false;

  constructor(private readonly onFailed: () => void) {}

  get failed(): boolean {
    return this.expired;
  }

  /** Starts timing at the outage's first failure; later calls keep its start. */
  start(): void {
    if (this.expired || this.timer) return;
    this.timer = setTimeout(() => {
      this.timer = null;
      this.expired = true;
      this.onFailed();
    }, FAILED_AFTER_MS);
  }

  /** The outage ended: connected again, or closed on purpose. */
  stop(): void {
    if (this.timer) {
      clearTimeout(this.timer);
      this.timer = null;
    }
    this.expired = false;
  }
}
